import { useEffect, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';

const useCurrentUser = () => {
  const [user, setUser] = useState(null);
  
  const parsedUserData = function () {
    const localStorageToken = secureLocalStorage.getItem('userDetails');
    let parsedJson = null;

    if (localStorageToken) {
      try {
        parsedJson = JSON.parse(localStorageToken);
      } catch {}
    }

    return parsedJson;
  };

  useEffect(() => {
    // Set initial user data
    setUser(parsedUserData());
    
    // Set up an interval to check for localStorage changes
    const checkForUserChanges = () => {
      const currentUserData = parsedUserData();
      setUser(prevUser => {
        // Only update if the user data has actually changed
        const prevUserId = prevUser?.id || prevUser?.userId;
        const currentUserId = currentUserData?.id || currentUserData?.userId;
        
        if (prevUserId !== currentUserId) {
          return currentUserData;
        }
        return prevUser;
      });
    };

    // Check for changes every 100ms (this will catch login/logout changes quickly)
    const interval = setInterval(checkForUserChanges, 100);

    return () => clearInterval(interval);
  }, []);

  return user;
};

export default useCurrentUser;
